import { pstyle } from "../lib/pstyle.js";
import Hoverable from "../lib/Hoverable.jsx";
import Account from "./Account.jsx";

export default function Header({ v }) {
  return (
    <header className="nd-header" style={pstyle("position:sticky; top:0; z-index:20; display:flex; align-items:center; gap:24px; padding:0 44px; height:60px; border-bottom:1px solid oklch(0.94 0.006 85); background:oklch(1 0 0);")}>
      <button type="button" onClick={v.goHome} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; color:inherit; display:flex; align-items:center; gap:8px; font-size:15px; font-weight:600; letter-spacing:-0.01em; cursor:pointer;")}>
        <span style={pstyle("width:9px; height:9px; border-radius:3px; background:oklch(0.46 0.075 55);")}></span>netdoc
      </button>
      <Hoverable
        onClick={v.openSearch}
        className="nd-header-search"
        style={pstyle("display:flex; align-items:center; gap:10px; width:320px; border:1px solid oklch(0.92 0.008 85); border-radius:8px; padding:7px 12px; font-size:13px; color:oklch(0.55 0.015 60); cursor:pointer;")}
        hoverStyle={{ borderColor: "oklch(0.82 0.012 85)" }}
      >
        <span>Rechercher…</span>
        <span style={pstyle("margin-left:auto; font-family:'IBM Plex Mono', monospace; font-size:11px;")}>⌘K</span>
      </Hoverable>
      <nav className="nd-header-nav" style={pstyle("margin-left:auto; display:flex; align-items:center; gap:20px; font-size:13.5px; color:oklch(0.45 0.015 60);")}>
        <button type="button" onClick={v.goHome} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; color:inherit; cursor:pointer;")}>Wiki</button>
        <button type="button" onClick={v.goCourse} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; color:inherit; cursor:pointer;")}>Cours</button>
        <div style={pstyle("position:relative; display:flex; align-items:center;")}>
          <button type="button" onClick={v.toggleToolsMenu} aria-expanded={v.toolsMenuOpen} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; cursor:pointer;", { color: v.toolsNavColor })}>Outils ▾</button>
          {v.toolsMenuOpen && (
            <div style={pstyle("position:absolute; top:30px; right:-8px; width:268px; background:oklch(1 0 0); border:1px solid oklch(0.9 0.01 85); border-radius:9px; box-shadow:0 14px 34px oklch(0.2 0.01 60 / 0.14); padding:6px; display:flex; flex-direction:column; z-index:30;")}>
              {v.toolLinks.map((t, i) => (
                <Hoverable
                  key={i}
                  onClick={t.onClick}
                  style={pstyle("padding:9px 10px; border-radius:6px; cursor:pointer; display:flex; flex-direction:column; gap:2px;")}
                  hoverStyle={{ background: "oklch(0.975 0.006 85)" }}
                >
                  <span style={pstyle("font-size:13.5px; color:oklch(0.28 0.015 60);")}>{t.label}</span>
                  <span style={pstyle("font-size:11.5px; line-height:1.4; color:oklch(0.53 0.015 60);")}>{t.desc}</span>
                </Hoverable>
              ))}
            </div>
          )}
        </div>
        <button type="button" onClick={v.goRevise} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; color:inherit; cursor:pointer;")}>Révision</button>
        <button type="button" onClick={v.goCertif} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; color:inherit; cursor:pointer;")}>Certif</button>
        <button type="button" onClick={v.goIndex} style={pstyle("background:none; border:none; padding:0; margin:0; font:inherit; color:inherit; cursor:pointer;")}>Index A→Z</button>
        <Account v={v} />
      </nav>
    </header>
  );
}
